import GeoTrackingList from "../../../components/mobile/geoTracking/GeoAttendenceTracking";

const GeoAttendanceTrackingPage: React.FC = () => {
  return <GeoTrackingList />;
};

export default GeoAttendanceTrackingPage;
